import React = require('react')
import { JumboProps, isHomeJumbo, renderContents } from '../../custom_components/components/jumbo'
import { LinkButton } from '../../custom_components/components/library/button'
import { trackJumboButton } from '../../custom_components/components/library/tracking'
import { BranchLocalizationLayout } from '../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout'


const homeJumbo = (props: JumboProps) => (
  <header className="jumbotron jumbotron--large jumbotron--home">
    {isHomeJumbo(props) && <BranchLocalizationLayout {...props.localizationProps} />}
    <div className="jumbotron__outer">
      <div className="jumbotron__inner container--full gutter--m align--center">
        <div className="jumbotron__content container--s">
          <h1 className="jumbotron__title title--xl">{props.title}</h1>

          {props.contents.toString().length > 0 || (props.buttonUrl && props.buttonTitle) ? (
            <div className="jumbotron__intro">
              <div className="text--styled">
                {props.contents.toString().length > 0 && renderContents(props.contents, <div />, <div />)}
              </div>

              {props.buttonUrl && props.buttonTitle && (
                <LinkButton
                  variant="black"
                  arrow={false}
                  route={props.buttonUrl}
                  handle={() => trackJumboButton(props.buttonTitle)}
                  className="button button--primary button--arrow jumbotron__clickable"
                >
                  <span className="button__label">{props.buttonTitle}</span>
                </LinkButton>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>

        {props.imageUrl && (
          <div className="jumbotron__visual fit-object" aria-hidden="true">
            <img
              src={props.imageUrlSmall}
              srcSet={`${props.imageUrlSmall} 470w, ${props.imageUrl} 940w, ${props.imageUrlLarge} 1880w`}
              width="940"
              height="940"
              alt={props.imageAlt}
            />
          </div>
        )}
      </div>
    </div>
  </header>
)

export default homeJumbo
